import React from "react";
import classnames from "classnames";
import Button from "components/Button";
import { Card } from "react-bootstrap";
import { noop } from "lodash";

import { FaCheckCircle } from "react-icons/fa";
import IconSpinner from "components/IconSpinner";

import "./ActionCard.scss";

interface ActionCardProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  actionText?: string;
  completedAction?: boolean;
  loading?: boolean;
  disabled?: boolean;
  // Button's `color` is a literal union; mirror it so the value forwards cleanly.
  color?: React.ComponentProps<typeof Button>["color"];
  withArrow?: boolean;
}

export const ActionCard = ({
  onClick,
  icon,
  color,
  title,
  description,
  actionText,
  completedAction,
  loading,
  disabled,
  withArrow,
}: ActionCardProps) => {
  return (
    <Card>
      <Card.Body>
        <div>
          <div className="action-card-details">
            {icon && (
              <div className="action-icon-container">
                <div
                  className={`action-icon-circle ${
                    color === "red" ? "red-color" : "primary-color"
                  }`}
                >
                  <div className="action-icon">{icon}</div>
                </div>
              </div>
            )}
            <h5 className="action-card-title">{title}</h5>
            <p className="action-card-description">{description}</p>
          </div>
          {!completedAction && !loading && (
            <div className={classnames("action-card-action", { disabled })}>
              <Button
                size="sm"
                name="action"
                color={color}
                withArrow={withArrow}
                onClick={disabled ? noop : onClick}
              >
                {actionText}
              </Button>
            </div>
          )}
          {completedAction && (
            <div className="action-card-action completed-action">
              <div className="success-icon">
                <FaCheckCircle size={24} color="#4BB543" />
              </div>
            </div>
          )}
          {loading && (
            <div className="action-card-action action-card-loading">
              <IconSpinner />
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ActionCard;
